<template>
  <QuestionBase :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
                :question="question"
                :valid="data !== null">
    <InputSelect v-model="data"
                 :args="args"
                 :db="db"
                 :errors-post="errorsPost"
                 :js-errors="jsErrors"
                 :no-save="noSave"
                 :options="commitmentTypeOptions"
                 :skipped="skipped"
                 @jsErrors="jsErrors=$event"
                 @serverErrors="serverErrors=$event"
                 @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../helpers/questionLoadHelpers";
import {commitmentOptions} from "../../options/commitmentOptions";

import QuestionBase from "../../QuestionBase";
import InputSelect from "../../inputs/InputSelect";

export default {
  name: 'Type',
  mixins: [
    questionLoadHelpers,
    commitmentOptions
  ],
  components: {
    InputSelect,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    noSave: {
      type: Boolean,
      default: false
    },
    objectId: {
      type: Number,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'How would you describe the commitment?',
        subTitle: 'Instead of selecting from the list you can type the description.',
        tip: null
      },
      db: {
        saveLocation: 'client_commitment',
        saveField: 'commitmentType',
        objectId: this.objectId
      },
      args: {
        taggable: true,
        label: null,
        placeholder: 'Please select..',
        skippable: false,
        required: true,
        inputClass: 'field-75'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>